import ErrorBoundary from 'components/ErrorBoundary';
import GlobalLayout from 'components/GlobalLayout';
import GlobalMessage from 'components/GlobalMessage';
import GlobalModal from 'components/GlobalModal';
import { LiveChatAnchor } from 'components/LiveChat';
import { AlertProvider } from 'hooks/useAlert';
import StickyAlert from 'components/StickyAlert';

const App = ({ children }) => (
  <ErrorBoundary>
    <AlertProvider>
      <GlobalMessage />
      <GlobalLayout>{children}</GlobalLayout>
      <LiveChatAnchor />
      <GlobalModal />
      <StickyAlert />
    </AlertProvider>
  </ErrorBoundary>
);

export default App;
